export default [
    {
        "District":"Arghanj Khwa",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Argo",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Baharak",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Darayim",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Fayzabad",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Ishkashim",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Jurm",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Khash",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Khwahan",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Kishim",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Kohistan",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Kuf Ab",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Keran wa Menjan",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Maimay (Darwaz-e Payin)",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Nusay (Darwaz-e Bala)",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Raghistan",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Shahri Buzurg",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Sheghnan",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Shekay",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Shuhada",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Tagab",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Tishkan",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Wakhan",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Warduj",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Yaftali Sufla",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Yamgan",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Yawan",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Zebak",
        "Province":"Badakhshan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Ab Kamari",
        "Province":"Badghis",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Ghormach",
        "Province":"Badghis",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Jawand",
        "Province":"Badghis",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Muqur",
        "Province":"Badghis",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Bala Murghab",
        "Province":"Badghis",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Qadis",
        "Province":"Badghis",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Qala i Naw",
        "Province":"Badghis",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Andarab",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Baghlani Jadid",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Burka",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Dahana-I-Ghuri",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Dih Salah",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Dushi",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Farang Wa Gharu",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Guzargahi Nur",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Khinjan",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Khost Wa Fereng",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Khwaja Hijran",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Nahrin",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Puli Hisar",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Puli Khumri",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Tala wa Barfak",
        "Province":"Baghlan",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Balkh",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Charbolak",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Charkint",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Chimtal",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Dawlatabad",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Dihdadi",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Kaldar",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Khulm",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Kishindih",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Marmul",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Nahri Shahi",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Sholgara",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Shortepa",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Zari",
        "Province":"Balkh",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Bamyan",
        "Province":"Bamyan",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Kahmard",
        "Province":"Bamyan",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Panjab",
        "Province":"Bamyan",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Sayghan",
        "Province":"Bamyan",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Shibar",
        "Province":"Bamyan",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Waras",
        "Province":"Bamyan",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Yakawlang",
        "Province":"Bamyan",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Yakawlang 2",
        "Province":"Bamyan",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Ishtarlay",
        "Province":"Daykundi",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Kijran",
        "Province":"Daykundi",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Khedir",
        "Province":"Daykundi",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Kitti",
        "Province":"Daykundi",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Miramor",
        "Province":"Daykundi",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Nili",
        "Province":"Daykundi",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Sangi Takht",
        "Province":"Daykundi",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Shahristan",
        "Province":"Daykundi",
        "Region Name":"Bamyan",
        "Region ABRV":"BMN ",
        "Region NO":"RGN 001",
        "Region Code":"BMN - RGN 001"
    },
    {
        "District":"Anar Dara",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Bakwa",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Bala Buluk",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Farah",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Gulistan",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Khaki Safed",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Lash Wa Juwayn",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Pur Chaman",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Pusht Rod",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Qala-I-Kah\/",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Pusht-e-Koh",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Shib Koh",
        "Province":"Farah",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Almar",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Andkhoy",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Bilchiragh",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Dawlat Abad",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Gurziwan",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Khani Char Bagh",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Khwaja Sabz Posh",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Kohistan",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Maymana",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Pashtun Kot",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Qaramqol",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Qaysar",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Qurghan",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Shirin Tagab",
        "Province":"Faryab",
        "Region Name":"Maymana",
        "Region ABRV":"FRB ",
        "Region NO":"RGN 002",
        "Region Code":"FRB - RGN 002"
    },
    {
        "District":"Ab Band",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Ajristan",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Andar",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Deh Yak",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Gelan",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Ghazni",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Giro",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Jaghori",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Jaghatū",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Khogyani",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Khwaja Umari",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Malistan",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Muqur",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Nawa",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Nawur",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Qarabagh",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Rashidan",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Waghaz",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Zana Khan",
        "Province":"Ghazni",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Chaghcharan",
        "Province":"Ghor",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Charsada",
        "Province":"Ghor",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Dawlat Yar",
        "Province":"Ghor",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Du Layna",
        "Province":"Ghor",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Lal wa Sarjangal",
        "Province":"Ghor",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Marghab",
        "Province":"Ghor",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Pasaband",
        "Province":"Ghor",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Saghar",
        "Province":"Ghor",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Shahrak",
        "Province":"Ghor",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Taywara",
        "Province":"Ghor",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Tulak",
        "Province":"Ghor",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Baghran",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Dishu",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Garmsir",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Kajaki",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Khanashin (Reg)",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Lashkargah",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Marjah",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Musa Qala",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Nad Ali",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Grishk (Nahri Saraj)",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Nawa-I-Barakzayi",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Nawzad",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Sangin",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Washir",
        "Province":"Helmand",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Adraskan",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Chishti Sharif",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Farsi",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Ghoryan",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Gulran",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Guzara",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Herat",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Injil\/Enjil",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Karukh",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Kohsan",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Kushk",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Kushki Kuhna",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Obe",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Pashtun Zarghun",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Shindand",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Zinda Jan",
        "Province":"Herat",
        "Region Name":"Herat",
        "Region ABRV":"HRT ",
        "Region NO":"RGN 005",
        "Region Code":"HRT - RGN 005"
    },
    {
        "District":"Jowzjan",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Aqcha",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Darzab",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Fayzabad",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Khamyab",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Khaniqa",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Khwaja Du Koh",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Mardyan",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Mingajik",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Qarqin",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Qush Tepa",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Sheberghan",
        "Province":"Jowzjan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Bagrami",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Chahar Asyab",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Deh Sabz",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Farza",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Guldara",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Istalif",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Kabul (city)",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Kalakan",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Khaki Jabbar",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Mir Bacha Kot",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Mussahi",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Paghman",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Qarabagh",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Shakardara",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Surobi",
        "Province":"Kabul",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Arghandab",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Arghistan",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Daman",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Ghorak",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Kandahar",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Khakrez",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Maruf",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Maiwand",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Miyanishin",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Nesh",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Panjwayi",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Reg",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Shah Wali Kot",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Shorabak",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Spin Boldak",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Takhta-pul",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Zhari",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Dand",
        "Province":"Kandahar",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Alasay",
        "Province":"Kapisa",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Hesa Awal Kohistan",
        "Province":"Kapisa",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Hesa Duwum Kohistan",
        "Province":"Kapisa",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Koh Band",
        "Province":"Kapisa",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Mahmud Raqi",
        "Province":"Kapisa",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Nijrab",
        "Province":"Kapisa",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Tagab",
        "Province":"Kapisa",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Bak",
        "Province":"Kapisa",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Gurbuz",
        "Province":"Kapisa",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Jaji Maydan",
        "Province":"Kapisa",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Khost",
        "Province":"Khost",
        "Region Name":"Khost",
        "Region ABRV":"KHST ",
        "Region NO":"RGN 007",
        "Region Code":"KHST - RGN 007"
    },
    {
        "District":"Mandozayi",
        "Province":"Khost",
        "Region Name":"Khost",
        "Region ABRV":"KHST ",
        "Region NO":"RGN 007",
        "Region Code":"KHST - RGN 007"
    },
    {
        "District":"Musa Khel",
        "Province":"Khost",
        "Region Name":"Khost",
        "Region ABRV":"KHST ",
        "Region NO":"RGN 007",
        "Region Code":"KHST - RGN 007"
    },
    {
        "District":"Nadir Shah Kot",
        "Province":"Khost",
        "Region Name":"Khost",
        "Region ABRV":"KHST ",
        "Region NO":"RGN 007",
        "Region Code":"KHST - RGN 007"
    },
    {
        "District":"Qalandar",
        "Province":"Khost",
        "Region Name":"Khost",
        "Region ABRV":"KHST ",
        "Region NO":"RGN 007",
        "Region Code":"KHST - RGN 007"
    },
    {
        "District":"Sabari",
        "Province":"Khost",
        "Region Name":"Khost",
        "Region ABRV":"KHST ",
        "Region NO":"RGN 007",
        "Region Code":"KHST - RGN 007"
    },
    {
        "District":"Shamal",
        "Province":"Khost",
        "Region Name":"Khost",
        "Region ABRV":"KHST ",
        "Region NO":"RGN 007",
        "Region Code":"KHST - RGN 007"
    },
    {
        "District":"Spera",
        "Province":"Khost",
        "Region Name":"Khost",
        "Region ABRV":"KHST ",
        "Region NO":"RGN 007",
        "Region Code":"KHST - RGN 007"
    },
    {
        "District":"Tani",
        "Province":"Khost",
        "Region Name":"Khost",
        "Region ABRV":"KHST ",
        "Region NO":"RGN 007",
        "Region Code":"KHST - RGN 007"
    },
    {
        "District":"Tirazayi",
        "Province":"Khost",
        "Region Name":"Khost",
        "Region ABRV":"KHST ",
        "Region NO":"RGN 007",
        "Region Code":"KHST - RGN 007"
    },
    {
        "District":"Asadabad",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Bar Kunar",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Chapa Dara",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Chawkay",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Dangam",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Dara-I-Pech",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Ghaziabad",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Khas Kunar",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Marawara",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Narang Aw Badil",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Nari",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Nurgal",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Shaigal",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Shultan",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Sirkani",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Wata Pur",
        "Province":"Kunar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Ali Abad",
        "Province":"Kunduz",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Archi",
        "Province":"Kunduz",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Chardara",
        "Province":"Kunduz",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Imam Sahib",
        "Province":"Kunduz",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Khan Abad",
        "Province":"Kunduz",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Kunduz",
        "Province":"Kunduz",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Qalay-I-Zal",
        "Province":"Kunduz",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Alingar",
        "Province":"Laghman",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Alishing",
        "Province":"Laghman",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Dawlat Shah",
        "Province":"Laghman",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Mihtarlam",
        "Province":"Laghman",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Qarghayi",
        "Province":"Laghman",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Logar",
        "Province":"Logar",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Azra",
        "Province":"Logar",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Baraki Barak",
        "Province":"Logar",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Charkh",
        "Province":"Logar",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Kharwar",
        "Province":"Logar",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Khoshi",
        "Province":"Logar",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Mohammad Agha",
        "Province":"Logar",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Puli Alam",
        "Province":"Logar",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Jalalabad",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Haska Meyna\/Deh Bala",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Shinwar",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Achin",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Bihsud",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Chaparhar",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Darai Nur",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Bati Kot",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Dur Baba",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Goshta",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Hisarak",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Kama",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Khogyani",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Kot",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Kuz Kunar",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Lal Pur",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Momand Dara",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Nazyan",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Pachir Aw Agam",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Rodat",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Sherzad",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Surkh Rod",
        "Province":"Nangarhar",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Chahar Burjak",
        "Province":"Nimruz",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Chakhansur",
        "Province":"Nimruz",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Kang",
        "Province":"Nimruz",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Khash Rod",
        "Province":"Nimruz",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Zaranj",
        "Province":"Nimruz",
        "Region Name":"Farah",
        "Region ABRV":"FRH ",
        "Region NO":"RGN 003",
        "Region Code":"FRH - RGN 003"
    },
    {
        "District":"Barg-i Matal",
        "Province":"Nuristan",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Du Ab",
        "Province":"Nuristan",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Kamdesh",
        "Province":"Nuristan",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Mandol",
        "Province":"Nuristan",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Nurgram",
        "Province":"Nuristan",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Parun",
        "Province":"Nuristan",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Wama",
        "Province":"Nuristan",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Waygal",
        "Province":"Nuristan",
        "Region Name":"Nangarhar",
        "Region ABRV":"NGR ",
        "Region NO":"RGN 0011",
        "Region Code":"NGR - RGN 0011"
    },
    {
        "District":"Ahmad Aba",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Ahmadkhel",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Dand Aw Patan",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Gardez",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Gerda Serai",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Janikhel District",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Laja Mangal District",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Mirzaka",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Rohani Baba",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Said Karam",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Shwak",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Chamkani",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Zadran",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Zazi (Jaji)",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Zurmat",
        "Province":"Paktia",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Barmal",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Dila",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Gayan",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Gomal",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Janikhel",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Khairkot (Zarghun Shar or Katawaz)",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Mata Khan",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Nika",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Omna",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Sar Hawza",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Surobi",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Sharana",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Terwa",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Urgun",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Wazakhwa",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Wor Mamay",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Yahyakhel",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Yusufkhel",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Zerok",
        "Province":"Paktika",
        "Region Name":"Ghazni",
        "Region ABRV":"GZNI ",
        "Region NO":"RGN 004",
        "Region Code":"GZNI - RGN 004"
    },
    {
        "District":"Abshar",
        "Province":"Panjshir",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Anaba",
        "Province":"Panjshir",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Bazarak",
        "Province":"Panjshir",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Darah",
        "Province":"Panjshir",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Khenj",
        "Province":"Panjshir",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Paryan",
        "Province":"Panjshir",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Rokha",
        "Province":"Panjshir",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Shotul",
        "Province":"Panjshir",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Bagram",
        "Province":"Parwan",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Charikar",
        "Province":"Parwan",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Ghorband",
        "Province":"Parwan",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Jabal Saraj",
        "Province":"Parwan",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Kohi Safi",
        "Province":"Parwan",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Salang",
        "Province":"Parwan",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Sayed Khel",
        "Province":"Parwan",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Sheikh Ali",
        "Province":"Parwan",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Shinwari",
        "Province":"Parwan",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Surkhi Parsa",
        "Province":"Parwan",
        "Region Name":"Parwan",
        "Region ABRV":"PRWN ",
        "Region NO":"RGN 0012",
        "Region Code":"PRWN - RGN 0012"
    },
    {
        "District":"Aybak",
        "Province":"Samangan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR",
        "Region NO":"RGN 0010",
        "Region Code":"MZR- RGN 0010"
    },
    {
        "District":"Darah Sof Balla",
        "Province":"Samangan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR",
        "Region NO":"RGN 0010",
        "Region Code":"MZR- RGN 0010"
    },
    {
        "District":"Darah Sof Payan",
        "Province":"Samangan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR",
        "Region NO":"RGN 0010",
        "Region Code":"MZR- RGN 0010"
    },
    {
        "District":"Feroz Nakhchir",
        "Province":"Samangan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR",
        "Region NO":"RGN 0010",
        "Region Code":"MZR- RGN 0010"
    },
    {
        "District":"Hazrat Sultan",
        "Province":"Samangan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR",
        "Region NO":"RGN 0010",
        "Region Code":"MZR- RGN 0010"
    },
    {
        "District":"Khuram Wa Sarbagh",
        "Province":"Samangan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR",
        "Region NO":"RGN 0010",
        "Region Code":"MZR- RGN 0010"
    },
    {
        "District":"Ruyi Du Ab",
        "Province":"Samangan",
        "Region Name":"Mazar",
        "Region ABRV":"MZR",
        "Region NO":"RGN 0010",
        "Region Code":"MZR- RGN 0010"
    },
    {
        "District":"Balkhab",
        "Province":"Sar-e Pol",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Gosfandi",
        "Province":"Sar-e Pol",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Kohistanat",
        "Province":"Sar-e Pol",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Sancharak",
        "Province":"Sar-e Pol",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Sare-Pol",
        "Province":"Sar-e Pol",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Sayyad",
        "Province":"Sar-e Pol",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Sozma Qala",
        "Province":"Sar-e Pol",
        "Region Name":"Mazar",
        "Region ABRV":"MZR ",
        "Region NO":"RGN 0010",
        "Region Code":"MZR - RGN 0010"
    },
    {
        "District":"Baharak",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Bangi",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Chah Ab",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Chal",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Darqad",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Dashti Qala",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Farkhar",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Hazar Sumuch",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Ishkamish",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Kalafgan",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Khwaja Bahauddin",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Khwaja Ghar",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Namak Ab",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Rustaq",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Taluqan",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Warsaj",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Yangi Qala",
        "Province":"Takhar",
        "Region Name":"Kunduz",
        "Region ABRV":"KNDZ ",
        "Region NO":"RGN 009",
        "Region Code":"KNDZ - RGN 009"
    },
    {
        "District":"Shahidi Hassas",
        "Province":"Uruzgan",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Chora",
        "Province":"Uruzgan",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Deh Rawood",
        "Province":"Uruzgan",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Gizab",
        "Province":"Uruzgan",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Khas Uruzgan",
        "Province":"Uruzgan",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Tarinkot",
        "Province":"Uruzgan",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Wardak",
        "Province":"Wardak",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Chaki Wardak",
        "Province":"Wardak",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Day Mirdad",
        "Province":"Wardak",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Hisa-I-Awali Bihsud",
        "Province":"Wardak",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Jaghatu",
        "Province":"Wardak",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Jalrez",
        "Province":"Wardak",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Markazi Bihsud",
        "Province":"Wardak",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Maidan Shar",
        "Province":"Wardak",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Nirkh",
        "Province":"Wardak",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Saydabad",
        "Province":"Wardak",
        "Region Name":"Kabul",
        "Region ABRV":"KBL ",
        "Region NO":"RGN 006",
        "Region Code":"KBL - RGN 006"
    },
    {
        "District":"Arghandab",
        "Province":"Zabul",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Atghar",
        "Province":"Zabul",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Daychopan",
        "Province":"Zabul",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Kakar",
        "Province":"Zabul",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Mezana",
        "Province":"Zabul",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Naw Bahar",
        "Province":"Zabul",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Qalat",
        "Province":"Zabul",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Shah Joy",
        "Province":"Zabul",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Shamulzayi",
        "Province":"Zabul",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Shinkay",
        "Province":"Zabul",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    },
    {
        "District":"Tarnak Aw Jaldak",
        "Province":"Zabul",
        "Region Name":"Kandahar",
        "Region ABRV":"KNDR ",
        "Region NO":"RGN 008",
        "Region Code":"KNDR - RGN 008"
    }
]